if (!customElements.get("trustpilot-rating")) {
  customElements.define(
    "trustpilot-rating",
    class TrustpilotRating extends HTMLElement {
      constructor() {
        super();

        this.id = this.getAttribute("data-tp-id");
        this.buid = this.getAttribute("data-buid");
        this.queryId = this.getAttribute("data-query-id");
        this.avgRating = this.querySelector(".tp-avg-rating");
        this.content = this.querySelector(".trustpilot-rating__content");

        this.scrollToReviews = this.getAttribute("data-scroll-to-reviews") === "true";
        this.scrollToReviewsSelector = '.section-trustpilot-product-reviews-carousel';

        this.sessionObjectName = "trustpilot-product-rating";
        this.sessionProductKey = `product-${this.id}`;
      }

      connectedCallback() {
        // only fetch if element comes into view
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {

              // check if rating is already in session storage
              const rating = this.checkSessionStorage();

              // if rating is "no-reviews", return
              if (rating === 'no reviews') {
                observer.disconnect();
                return;
              }

              // render rating if it's in session storage
              if (rating) {
                this.renderRating(rating);
                observer.disconnect();
                return;
              }

              // fetch rating
              this.getRating();
              observer.disconnect();
            }
          });
        });

        observer.observe(this);

        // scroll to reviews
        if (this.scrollToReviews) {
          this.addEventListener('click', this.scrollToReviewsElement);
        }
      }

      calculateRoundedRating(reviews) {
        if (!reviews || reviews.total === 0) return 0;

        const totalScore =
          (reviews.oneStar || 0) * 1 +
          (reviews.twoStars || 0) * 2 +
          (reviews.threeStars || 0) * 3 +
          (reviews.fourStars || 0) * 4 +
          (reviews.fiveStars || 0) * 5;

        const avg = totalScore / reviews.total;

        return Math.round(avg * 10) / 10;
      }

      getRating() {
        const url = `https://api.trustpilot.com/v1/product-reviews/business-units/${this.buid}?sku=${this.queryId}`;

        fetch(url, {
          method: 'GET',
          headers: {
              'apikey': window.tpk,
              'Content-Type': 'application/json'
          },
        }).then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('TrustPilot rating Network response was not ok.');
        }).then(data => {
          const calculatedRating = this.calculateRoundedRating(data.numberOfReviews);
          const finalRating =
            Number(calculatedRating) === Number(data.starsAverage)
              ? data.starsAverage
              : calculatedRating;
          this.renderRating(finalRating);
          this.saveInSessionStorage(finalRating);

        }).catch(error => {
          console.error('There has been a problem with TrustPilot rating fetch operation:', error);
        });
      }

      renderRating(starsAverage) {
        if (this.avgRating && this.content && starsAverage && starsAverage > 0) {
          this.avgRating.innerHTML = starsAverage;
          this.content.classList.remove("hidden");
        }
      }

      saveInSessionStorage(starsAverage) {

        const storage = sessionStorage.getItem(this.sessionObjectName);
        const storageData = storage ? JSON.parse(storage) : {};
        if(starsAverage === 0) {
          storageData[this.sessionProductKey] = 'no reviews';
        } else {
          storageData[this.sessionProductKey] = starsAverage;
        }
        sessionStorage.setItem(this.sessionObjectName, JSON.stringify(storageData));
      }

      checkSessionStorage() {
        const storage = sessionStorage.getItem(this.sessionObjectName);
        if (!storage) {
          return false;
        }
        const storageData = storage ? JSON.parse(storage) : {};
        if (!storageData[this.sessionProductKey]) {
          return false;
        }
        return storageData[this.sessionProductKey];
      }

      scrollToReviewsElement() {
        const reviewsElement = document.querySelector(this.scrollToReviewsSelector);
        if (reviewsElement) {
          reviewsElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  );
}